module.exports = __webpack_public_path__ + "08db349fd0a5d692b15f895ea3f1f93e.svg";